/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: mojmir.studenovsky@eurowag.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyContact,
    CompanyContactFromJSON,
    CompanyContactFromJSONTyped,
    CompanyContactToJSON,
    ShipperBillingInfo,
    ShipperBillingInfoFromJSON,
    ShipperBillingInfoFromJSONTyped,
    ShipperBillingInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface Shipper
 */
export interface Shipper {
    /**
     * 
     * @type {CompanyContact}
     * @memberof Shipper
     */
    companyContact: CompanyContact;
    /**
     * 
     * @type {ShipperBillingInfo}
     * @memberof Shipper
     */
    billingInfo: ShipperBillingInfo;
}

export function ShipperFromJSON(json: any): Shipper {
    return ShipperFromJSONTyped(json, false);
}

export function ShipperFromJSONTyped(json: any, ignoreDiscriminator: boolean): Shipper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyContact': CompanyContactFromJSON(json['companyContact']),
        'billingInfo': ShipperBillingInfoFromJSON(json['billingInfo']),
    };
}

export function ShipperToJSON(value?: Shipper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyContact': CompanyContactToJSON(value.companyContact),
        'billingInfo': ShipperBillingInfoToJSON(value.billingInfo),
    };
}


